import BaseModel from "./Base";

export default class Settlement extends BaseModel {
  static normalize(settlement) {
    return settlement;
  }
}
